module.exports = __webpack_public_path__ + "static/media/money.24fa4c65.png";